export interface Scopes {
    finances: string[];
    productOrder: string[];
    uploadOrder: string[];
    uploadBeesSpreadsheet: string[];
    comm_agreements: string[];
  }

  /** User Scopes */
export const scopes = {
    finances: ["LinkAdmin.WFin.Read"],
    productOrder: ["LinkAdmin.WOTake.Read"],
    uploadOrder: ["LinkAdmin.WOTake.Read"],
    uploadBeesSpreadsheet: ["LinkAdmin.WOTake.Read"],
    comm_agreements: [
      "Linkadmin.WChainAG.Read",
      "Linkadmin.WChainAG.Write",
      "LinkAdmin.WPocAG.Read",
      "LinkAdmin.WPocAG.Write"
    ]
  }